module.exports = __webpack_public_path__ + "static/media/2026-login-bg.8dff0e2b.png";